import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import '../styles/Footer.css';

function Footer() {
  return (
    <div className='footer'>
        <div className="socialMedia">
            <FontAwesomeIcon icon={faFacebookF} />
            <FontAwesomeIcon icon={faTwitter} />
            <FontAwesomeIcon icon={faInstagram} />
            <FontAwesomeIcon icon={faLinkedinIn} />
        </div>
        <p> &copy; 2025. All rights reserved.</p>
    </div>
  )
}

export default Footer